import React from 'react';

import { Schedules } from 'src/lib/resources';

import type { BackupScheduleRead } from '@ragu-components/ord-types';
import type { OrdResourceProps } from 'src/lib/resources';

const SchedulesList = React.lazy(async () => import('./SchedulesList'));

export const schedulesResource: OrdResourceProps = {
  key: Schedules,
  name: Schedules,
  list: <SchedulesList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: BackupScheduleRead): string => record.name,
};
